import React from "react";
import { useTranslation } from "react-i18next";
import FormatResourceStatusLabel from "go-app/components/FormatResourceStatus/FormatResourceStatus";
import { getComponentStatusClassName } from "go-component/Common/FormatStatus";

interface Props {
	status: string;
}

const CrashReportStatus = ({ status }: Props) => {
	const { t } = useTranslation();
	const labelClass = getStatusClassName(status);

	const translation = t(getStatusTranslationKey(status), { ns: ["translation", "lib"] });
	return <FormatResourceStatusLabel status={status} className={labelClass} translation={translation} />;
};

export default CrashReportStatus;

const getStatusTranslationKey = (status: string) => {
	return `enums.crash_reports.status.${status}`;
};

const getStatusClassName = (status: string) => {
	let labelClass = getComponentStatusClassName(status);
	if (labelClass) return labelClass;

	switch (status) {
		case "ARCHIVED":
			labelClass = "success";
			break;
		case "WORK_IN_PROGRESS":
			labelClass = "blue";
			break;
		case "OCCURRING":
			labelClass = "danger";
			break;
		case "PERMANENTLY_BROKEN":
		default:
			labelClass = "secondary";
			break;
	}
	return labelClass;
};
